module.exports = __webpack_public_path__ + "static/media/_MIC2537.thumbnail.f3073efc.png";